"use strict";
/**
 * Membership module (RBAC-2.1, AD-2.1-6) — ЕДИНСТВЕННЫЙ словарь оси C.
 *
 * До этой стори имена трёх ролей членства были объявлены независимо в трёх местах
 * (Core `shared/constants/merchant.ts`, merchant-backend `CoreBackendClient`,
 * merchant-admin `lib/utils/permissions.ts`) — F3 из анализа модели, воспроизведённая на
 * новой оси. Три копии одного правила расходятся молча, и слабейшая становится настоящим
 * гейтом; поверх них ложился бы ещё и словарь способностей.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./roles"), exports);
__exportStar(require("./capabilities"), exports);
